import CityPageTemplate from "@/pages/hawaii-city/CityPageTemplate";
import { waipahuConfig } from "./data";

export default function WaipahuPage() {
  return <CityPageTemplate config={waipahuConfig} />;
}